import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Offcanvas,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "../Sidebar/Common";

import LoadingOverlay from "./LoadingOverlay";
const DB_ACTION_TYPES = ["insert", "update", "delete", "bulk_insert", "bulk insert", "db_action", "database"];

export default class Eventactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      isSubmitting: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row) => row.eventactions_Id,
          sortable: true,
          cell: (row) => <span>{row.eventactions_Id}</span>,
        },
        {
          name: "Events Id",
          selector: (row) => row.events_Id,
          sortable: true,
          cell: (row) => <span>{row.events_Id}</span>,
        },
        {
          name: "Action Type",
          selector: (row) => row.actionType_Id,
          sortable: true,
          cell: (row) => <span>{this.getActionTypeName(row.actionType_Id)}</span>,
        },
        {
          name: "Target Table Name",
          selector: (row) => row.targetTableName,
          sortable: true,
          cell: (row) => <span>{row.targetTableName}</span>,
        },
        {
          name: "Email Templates Id",
          selector: (row) => row.emailtemplates_Id,
          sortable: true,
          cell: (row) => <span>{row.emailtemplates_Id}</span>,
        },
        {
          name: "Execution Order",
          selector: (row) => row.executionOrder,
          sortable: true,
          cell: (row) => <span>{row.executionOrder}</span>,
        },
        {
          name: "Is Active",
          selector: (row) => row.isActive,
          sortable: true,
          cell: (row) => <span>{row.isActive}</span>,
        },
        {
          name: "Mappings",
          sortable: false,
          cell: (row) => {
            const typeName = this.getActionTypeName(row.actionType_Id);
            const isDb = DB_ACTION_TYPES.includes((typeName || "").toLowerCase());
            return isDb ? (
              <span className={row._hasDbAction ? "text-success" : "text-warning"}>
                <i className={`bi ${row._hasDbAction ? "bi-check-circle-fill" : "bi-exclamation-triangle-fill"}`}></i>
                {row._hasDbAction ? " Configured" : " Missing"}
              </span>
            ) : (
              <span className="text-muted">N/A</span>
            );
          },
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.EventactionseditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 100,
      isEditing: false,
      eventactions_Id: "",
      events: [],
      events_Id: "",
      actiontypes: [],
      actionType_Id: "",
      targetTableName: "",
      emailtemplates_Id: "",
      executionOrder: "",
      apiCall: "",
      isActive: "",
      integrationlibrary_Id: "",
      // Field mapping state
      isDbAction: false,
      selectedActionTypeName: "",
      targetColumns: [],
      fieldMappings: {},
      whereConditions: {},
      loadingColumns: false,
      existingDbActionId: null,
      sourceTableColumns: [],
    };
  }

  // Get action type name from ID
  getActionTypeName = (actionTypeId) => {
    const found = this.state.actiontypes.find(
      (at) => String(at.eventactiontypemaster_Id) === String(actionTypeId)
    );
    return found ? found.actionType : actionTypeId;
  };

  // Check if selected action type is a DB action
  checkIsDbAction = (actionTypeId) => {
    const found = this.state.actiontypes.find(
      (at) => String(at.eventactiontypemaster_Id) === String(actionTypeId)
    );
    if (found) {
      const name = (found.actionType || "").toLowerCase();
      return DB_ACTION_TYPES.includes(name);
    }
    return false;
  };

  // Fetch target table columns
  fetchTargetColumns = (tableName) => {
    if (!tableName || tableName.trim() === "") {
      this.setState({ targetColumns: [], loadingColumns: false });
      return;
    }
    this.setState({ loadingColumns: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("tableName", tableName.trim());
    fetch(configData.api_url + "Masters/getColumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.columnsWT) {
          this.setState({ targetColumns: data.columnsWT, loadingColumns: false });
          // Auto-populate field mappings for columns that don't have mappings yet
          const existingMappings = { ...this.state.fieldMappings };
          data.columnsWT.forEach((col) => {
            if (!existingMappings[col.COLUMN_NAME]) {
              const lower = col.COLUMN_NAME.toLowerCase();
              if (["createdon", "created_on", "created_at"].includes(lower)) {
                existingMappings[col.COLUMN_NAME] = "{__now__}";
              } else if (["updatedon", "updated_on", "updated_at"].includes(lower)) {
                existingMappings[col.COLUMN_NAME] = "{__now__}";
              } else if (["createdby", "created_by"].includes(lower)) {
                existingMappings[col.COLUMN_NAME] = "{__triggeredBy__}";
              } else if (["updatedby", "updated_by"].includes(lower)) {
                existingMappings[col.COLUMN_NAME] = "{__triggeredBy__}";
              } else if (["status"].includes(lower)) {
                existingMappings[col.COLUMN_NAME] = "1";
              } else {
                existingMappings[col.COLUMN_NAME] = "{" + col.COLUMN_NAME + "}";
              }
            }
          });
          this.setState({ fieldMappings: existingMappings });
        } else {
          this.setState({ targetColumns: [], loadingColumns: false });
        }
      })
      .catch(() => {
        this.setState({ targetColumns: [], loadingColumns: false });
      });
  };

  // Fetch source table columns (from the event's sourceTableName)
  fetchSourceTableColumns = (eventsId) => {
    if (!eventsId) return;
    const event = this.state.events.find(
      (ev) => String(ev.events_Id) === String(eventsId)
    );
    if (event && event.sourceTableName) {
      var formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("tableName", event.sourceTableName);
      fetch(configData.api_url + "Masters/getColumns", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success" && data.columns) {
            this.setState({ sourceTableColumns: data.columns });
          }
        })
        .catch(() => {});
    }
  };

  // Load existing field mappings for an event
  loadExistingFieldMappings = (eventsId) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("events_Id", eventsId);
    fetch(configData.api_url + "C_Eventactions/getFieldMappings", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          const detail = data.detail;
          let fieldMappings = {};
          let whereConditions = {};
          try {
            fieldMappings = JSON.parse(detail.fieldMapping || "{}");
          } catch (e) { /* ignore */ }
          try {
            whereConditions = JSON.parse(detail.whereConditions || "{}");
          } catch (e) { /* ignore */ }
          this.setState({
            fieldMappings,
            whereConditions,
            existingDbActionId: detail.dbactions_Id,
          });
        }
      })
      .catch(() => {});
  };

  // Save field mappings
  saveFieldMappings = (eventsId, actionTypeName, targetTableName, executionOrder) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("events_Id", eventsId);
    formData.append("actionType", (actionTypeName || "insert").toLowerCase());
    formData.append("targetTableName", targetTableName);
    formData.append("fieldMapping", JSON.stringify(this.state.fieldMappings));
    formData.append("whereConditions", JSON.stringify(this.state.whereConditions));
    formData.append("executionOrder", executionOrder || "1");

    fetch(configData.api_url + "C_Eventactions/saveFieldMappings", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast("Field mappings saved", "success");
        } else {
          this.showToast("Failed to save field mappings: " + data.message, "error");
        }
      })
      .catch((error) => {
        console.error("Save field mappings error:", error);
        this.showToast("Failed to save field mappings", "error");
      });
  };

  // Validation
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;
    let validationResult = { isValid: true, message: "" };

    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value, parseInt(validationOptions.maxLength), fieldDisplayName
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;
      case "mail":
      case "email":
        validationResult = ValidationUtils.validateEmail(value);
        break;
      case "telephone":
      case "phone":
        validationResult = ValidationUtils.validatePhone(value);
        break;
      case "number":
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;
      case "password":
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;
      default:
        validationResult = { isValid: true, message: "" };
    }

    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }
    this.setState({ errors });
    return validationResult.isValid;
  };

  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true },
    });
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({ touched: { ...this.state.touched, [fieldName]: true } });
    this.validateField(fieldName, value, fieldConfig);
  };

  isFormValid = () => {
    return Object.keys(this.state.errors).length === 0;
  };

  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: "events_Id", inputType: "Select", displayName: "Events Id", validationOptions: { isRequired: false } },
      { fieldName: "actionType_Id", inputType: "Select", displayName: "Action Type Id", validationOptions: { isRequired: false } },
      { fieldName: "targetTableName", inputType: "Text", displayName: "Target Table Name", validationOptions: { isRequired: false } },
      { fieldName: "emailtemplates_Id", inputType: "Number", displayName: "Email Templates Id", validationOptions: { isRequired: false } },
      { fieldName: "executionOrder", inputType: "Text", displayName: "Execution Order", validationOptions: { isRequired: false } },
      { fieldName: "apiCall", inputType: "Text", displayName: "Api Call", validationOptions: { isRequired: false } },
      { fieldName: "isActive", inputType: "Number", displayName: "Is Active", validationOptions: { isRequired: false } },
    ];
    fieldConfigs.forEach((config) => {
      this.validateField(config.fieldName, this.state[config.fieldName], config);
    });
    const touched = {};
    fieldConfigs.forEach((config) => { touched[config.fieldName] = true; });
    this.setState({ touched });
  };

  // Offcanvas
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      events_Id: "",
      actionType_Id: "",
      targetTableName: "",
      emailtemplates_Id: "",
      executionOrder: "",
      apiCall: "",
      isActive: "",
      integrationlibrary_Id: "",
      isDbAction: false,
      selectedActionTypeName: "",
      targetColumns: [],
      fieldMappings: {},
      whereConditions: {},
      existingDbActionId: null,
      sourceTableColumns: [],
    });
  };

  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      events_Id: "",
      actionType_Id: "",
      targetTableName: "",
      emailtemplates_Id: "",
      executionOrder: "",
      apiCall: "",
      isActive: "",
      integrationlibrary_Id: "",
      isDbAction: false,
      selectedActionTypeName: "",
      targetColumns: [],
      fieldMappings: {},
      whereConditions: {},
      existingDbActionId: null,
      sourceTableColumns: [],
    });
  };

  showToast = (msg, type) => {
    switch (type) {
      case "success": toast.success(msg); break;
      case "error": toast.error(msg); break;
      case "warning": toast.warn(msg); break;
      default: toast.info(msg);
    }
  };

  EventactionseditHandler = (row) => {
    const isDb = this.checkIsDbAction(row.actionType_Id);
    const typeName = this.getActionTypeName(row.actionType_Id);
    this.setState({
      isEditing: true,
      show: true,
      eventactions_Id: row.eventactions_Id,
      events_Id: row.events_Id,
      actionType_Id: row.actionType_Id,
      targetTableName: row.targetTableName,
      emailtemplates_Id: row.emailtemplates_Id,
      executionOrder: row.executionOrder,
      apiCall: row.apiCall,
      isActive: row.isActive,
      integrationlibrary_Id: row.integrationlibrary_Id,
      errors: {},
      touched: {},
      isDbAction: isDb,
      selectedActionTypeName: typeName,
      targetColumns: [],
      fieldMappings: {},
      whereConditions: {},
      existingDbActionId: null,
      sourceTableColumns: [],
    }, () => {
      if (isDb) {
        this.loadExistingFieldMappings(row.events_Id);
        if (row.targetTableName) {
          this.fetchTargetColumns(row.targetTableName);
        }
        this.fetchSourceTableColumns(row.events_Id);
      }
    });
  };

  EventactionsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Eventactions/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Enrich rows with dbaction status
          this.enrichWithDbActionStatus(data.list);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };

  // Check which eventactions have dbactions configured
  enrichWithDbActionStatus = (list) => {
    // Get unique events_Ids for DB-type actions
    const eventsToCheck = [];
    list.forEach((row) => {
      const isDb = this.checkIsDbAction(row.actionType_Id);
      if (isDb && !eventsToCheck.includes(row.events_Id)) {
        eventsToCheck.push(row.events_Id);
      }
    });

    if (eventsToCheck.length === 0) {
      this.setState({ data: list });
      return;
    }

    // Fetch dbactions for each event to check if mappings exist
    const promises = eventsToCheck.map((evId) => {
      var formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("events_Id", evId);
      return fetch(configData.api_url + "C_Eventactions/getFieldMappings", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((r) => r.json())
        .then((d) => ({ events_Id: evId, hasMapping: !!(d.detail) }))
        .catch(() => ({ events_Id: evId, hasMapping: false }));
    });

    Promise.all(promises).then((results) => {
      const mappingMap = {};
      results.forEach((r) => { mappingMap[r.events_Id] = r.hasMapping; });
      const enriched = list.map((row) => ({
        ...row,
        _hasDbAction: mappingMap[row.events_Id] || false,
      }));
      this.setState({ data: enriched });
    });
  };

  EventactionssubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      this.setState({ isSubmitting: false });
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("events_Id", this.state.events_Id);
    formData.append("actionType_Id", this.state.actionType_Id);
    formData.append("targetTableName", this.state.targetTableName);
    formData.append("emailtemplates_Id", this.state.emailtemplates_Id);
    formData.append("executionOrder", this.state.executionOrder);
    formData.append("apiCall", this.state.apiCall);
    formData.append("isActive", this.state.isActive);
    formData.append("integrationlibrary_Id", this.state.integrationlibrary_Id);
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Eventactions/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // Save field mappings if DB action with mappings configured
          if (this.state.isDbAction && Object.keys(this.state.fieldMappings).length > 0) {
            this.saveFieldMappings(
              this.state.events_Id,
              this.state.selectedActionTypeName,
              this.state.targetTableName,
              this.state.executionOrder
            );
          }
          this.EventactionsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });})
      .finally(() => this.setState({ isSubmitting: false }));
  };

  EventactionsupdateHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      this.setState({ isSubmitting: false });
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("eventactions_Id", this.state.eventactions_Id);
    formData.append("events_Id", this.state.events_Id);
    formData.append("actionType_Id", this.state.actionType_Id);
    formData.append("targetTableName", this.state.targetTableName);
    formData.append("emailtemplates_Id", this.state.emailtemplates_Id);
    formData.append("executionOrder", this.state.executionOrder);
    formData.append("apiCall", this.state.apiCall);
    formData.append("isActive", this.state.isActive);
    formData.append("integrationlibrary_Id", this.state.integrationlibrary_Id);
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Eventactions/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // Save field mappings if DB action
          if (this.state.isDbAction && Object.keys(this.state.fieldMappings).length > 0) {
            this.saveFieldMappings(
              this.state.events_Id,
              this.state.selectedActionTypeName,
              this.state.targetTableName,
              this.state.executionOrder
            );
          }
          this.EventactionsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });})
      .finally(() => this.setState({ isSubmitting: false }));
  };

  componentDidMount() {
    this.actiontypesfetchHandler(() => {
      this.EventactionsfetchHandler();
    });
    this.eventsfetchHandler();
  }

  handleevents_IdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ events_Id: fieldValue }, () => {
      if (this.state.isDbAction) {
        this.fetchSourceTableColumns(fieldValue);
      }
    });
  };

  eventsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Events/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ events: data.list });
        }
      });
  };

  handleactionType_IdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    const isDb = this.checkIsDbAction(fieldValue);
    const typeName = this.getActionTypeName(fieldValue);
    this.setState({
      actionType_Id: fieldValue,
      isDbAction: isDb,
      selectedActionTypeName: typeName,
    }, () => {
      if (isDb && this.state.targetTableName) {
        this.fetchTargetColumns(this.state.targetTableName);
      }
      if (isDb && this.state.events_Id) {
        this.fetchSourceTableColumns(this.state.events_Id);
      }
    });
  };

  actiontypesfetchHandler = (callback) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Eventactiontypemaster/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ actiontypes: data.list }, () => {
            if (callback) callback();
          });
        }
      });
  };

  handletargetTableNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ targetTableName: fieldValue });
    // Debounce column fetch
    if (this._targetTableTimer) clearTimeout(this._targetTableTimer);
    if (this.state.isDbAction && fieldValue.trim()) {
      this._targetTableTimer = setTimeout(() => {
        this.fetchTargetColumns(fieldValue);
      }, 600);
    }
  };

  handleemailtemplates_IdChange = (e) => {
    e.preventDefault();
    this.setState({ emailtemplates_Id: e.target.value });
  };
  handleexecutionOrderChange = (e) => {
    e.preventDefault();
    this.setState({ executionOrder: e.target.value });
  };
  handleapiCallChange = (e) => {
    e.preventDefault();
    this.setState({ apiCall: e.target.value });
  };
  handleisActiveChange = (e) => {
    e.preventDefault();
    this.setState({ isActive: e.target.value });
  };
  handleintegrationlibrary_IdChange = (e) => {
    e.preventDefault();
    this.setState({ integrationlibrary_Id: e.target.value });
  };

  handleRowSelect = (row) => {
    this.setState({ selectedRow: row.index });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row) => {
    if (!window.confirm("Are you sure you want to delete this eventaction?")) {
      return;
    }
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });

    var formData = new FormData();
    formData.append("eventactions_Id", row.eventactions_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Eventactions/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.EventactionsfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });})
      .finally(() => this.setState({ isSubmitting: false }));
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Handle field mapping value change
  handleMappingChange = (columnName, value) => {
    this.setState({
      fieldMappings: {
        ...this.state.fieldMappings,
        [columnName]: value,
      },
    });
  };

  // Handle where condition change
  handleWhereChange = (columnName, value) => {
    this.setState({
      whereConditions: {
        ...this.state.whereConditions,
        [columnName]: value,
      },
    });
  };

  // Remove a field mapping
  handleRemoveMapping = (columnName) => {
    const mappings = { ...this.state.fieldMappings };
    delete mappings[columnName];
    this.setState({ fieldMappings: mappings });
  };

  // Render field mapping section
  renderFieldMappingSection = () => {
    const { isDbAction, targetColumns, fieldMappings, loadingColumns, sourceTableColumns, selectedActionTypeName } = this.state;

    if (!isDbAction) return null;

    const isUpdateOrDelete = ["update", "delete"].includes((selectedActionTypeName || "").toLowerCase());

    return (
      <div style={{ marginTop: "15px", borderTop: "2px solid #0d6efd", paddingTop: "15px" }}>
        <h6 style={{ color: "#0d6efd", marginBottom: "10px" }}>
          <i className="bi bi-diagram-3 me-2"></i>
          Field Mappings
          <span style={{ fontSize: "0.75rem", color: "#6c757d", marginLeft: "8px" }}>
            (Map source data to target table columns)
          </span>
        </h6>

        {loadingColumns && (
          <div className="text-center py-3">
            <Spinner animation="border" size="sm" className="me-2" />
            Loading columns...
          </div>
        )}

        {!loadingColumns && targetColumns.length === 0 && this.state.targetTableName && (
          <div className="alert alert-warning py-2" style={{ fontSize: "0.85rem" }}>
            <i className="bi bi-exclamation-triangle me-1"></i>
            Enter a valid target table name to load columns.
          </div>
        )}

        {!loadingColumns && targetColumns.length > 0 && (
          <>
            <div style={{ fontSize: "0.8rem", color: "#6c757d", marginBottom: "8px" }}>
              Use <code>{"{columnName}"}</code> for direct mapping, <code>{"{__now__}"}</code> for current timestamp,
              <code>{" {__triggeredBy__}"}</code> for user ID, or enter a fixed value.
            </div>

            <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "4px" }}>
              <table className="table table-sm table-bordered mb-0" style={{ fontSize: "0.85rem" }}>
                <thead style={{ position: "sticky", top: 0, background: "#f8f9fa" }}>
                  <tr>
                    <th style={{ width: "35%" }}>Target Column</th>
                    <th style={{ width: "50%" }}>Source / Value</th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      <i className="bi bi-gear"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {targetColumns.map((col) => {
                    const colName = col.COLUMN_NAME;
                    const isPK = colName.toLowerCase().endsWith("_id") && colName.toLowerCase() === (this.state.targetTableName.toLowerCase() + "_id");
                    return (
                      <tr key={colName} style={isPK ? { background: "#fff3cd" } : {}}>
                        <td>
                          <span title={`${col.COLUMN_TYPE} ${col.IS_NULLABLE === "NO" ? "(NOT NULL)" : ""}`}>
                            {colName}
                          </span>
                          <br />
                          <small className="text-muted">{col.DATA_TYPE}</small>
                          {isPK && <small className="text-warning ms-1">(PK - auto)</small>}
                        </td>
                        <td>
                          {isPK ? (
                            <span className="text-muted fst-italic">Auto-increment</span>
                          ) : (
                            <div className="d-flex align-items-center">
                              {sourceTableColumns.length > 0 ? (
                                <select
                                  className="form-select form-select-sm"
                                  value={fieldMappings[colName] || ""}
                                  onChange={(e) => this.handleMappingChange(colName, e.target.value)}
                                >
                                  <option value="">-- Select or type --</option>
                                  <optgroup label="Source Columns">
                                    {sourceTableColumns.map((sc) => (
                                      <option key={sc} value={"{" + sc + "}"}>{sc}</option>
                                    ))}
                                  </optgroup>
                                  <optgroup label="Placeholders">
                                    <option value="{__now__}">Current Timestamp</option>
                                    <option value="{__triggeredBy__}">Triggered By (User ID)</option>
                                  </optgroup>
                                  <optgroup label="Fixed Values">
                                    <option value="1">1 (Active)</option>
                                    <option value="0">0 (Inactive)</option>
                                  </optgroup>
                                  {fieldMappings[colName] && !sourceTableColumns.includes(fieldMappings[colName].replace(/[{}]/g, "")) &&
                                    fieldMappings[colName] !== "{__now__}" &&
                                    fieldMappings[colName] !== "{__triggeredBy__}" &&
                                    fieldMappings[colName] !== "1" &&
                                    fieldMappings[colName] !== "0" && (
                                      <option value={fieldMappings[colName]}>{fieldMappings[colName]} (custom)</option>
                                    )
                                  }
                                </select>
                              ) : (
                                <Form.Control
                                  type="text"
                                  size="sm"
                                  value={fieldMappings[colName] || ""}
                                  onChange={(e) => this.handleMappingChange(colName, e.target.value)}
                                  placeholder="{sourceColumn}"
                                />
                              )}
                            </div>
                          )}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {!isPK && fieldMappings[colName] && (
                            <Button
                              variant="link"
                              size="sm"
                              className="text-danger p-0"
                              onClick={() => this.handleRemoveMapping(colName)}
                              title="Remove mapping"
                            >
                              <i className="bi bi-x-circle"></i>
                            </Button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Where conditions for Update/Delete */}
            {isUpdateOrDelete && (
              <div style={{ marginTop: "12px" }}>
                <h6 style={{ color: "#dc3545", fontSize: "0.9rem" }}>
                  <i className="bi bi-funnel me-1"></i>
                  WHERE Conditions
                  <span style={{ fontSize: "0.75rem", color: "#6c757d", marginLeft: "8px" }}>
                    (Required for update/delete)
                  </span>
                </h6>
                {targetColumns
                  .filter((col) => {
                    const lower = col.COLUMN_NAME.toLowerCase();
                    return lower.endsWith("_id") || lower === "id";
                  })
                  .map((col) => (
                    <Row key={"where_" + col.COLUMN_NAME} className="mb-2">
                      <Col lg="4">
                        <Form.Label style={{ fontSize: "0.85rem" }}>{col.COLUMN_NAME} =</Form.Label>
                      </Col>
                      <Col lg="8">
                        <Form.Control
                          type="text"
                          size="sm"
                          value={this.state.whereConditions[col.COLUMN_NAME] || ""}
                          onChange={(e) => this.handleWhereChange(col.COLUMN_NAME, e.target.value)}
                          placeholder={"{" + col.COLUMN_NAME + "}"}
                        />
                      </Col>
                    </Row>
                  ))
                }
              </div>
            )}

            <div className="mt-2">
              <small className="text-muted">
                <i className="bi bi-info-circle me-1"></i>
                {Object.keys(fieldMappings).filter((k) => fieldMappings[k]).length} of {targetColumns.length} columns mapped
              </small>
            </div>
          </>
        )}
      </div>
    );
  };

  // Render the form fields (shared between add and edit)
  renderFormFields = () => {
    return (
      <Form>
        <Row>
          <Col lg="4" md="4">
            <Form.Label style={{ paddingTop: "8px" }}>Event</Form.Label>
          </Col>
          <Col lg="8" md="8">
            <select
              className="form-select"
              value={this.state.events_Id}
              onChange={this.handleevents_IdChange}
            >
              <option value="">Select Event</option>
              {this.state.events.map((api, index) => (
                <option key={index} value={api.events_Id}>
                  {api.eventName || api.events_Id} ({api.sourceTableName} - {api.eventType})
                </option>
              ))}
            </select>
            <div className="errorMsg" style={{ color: "red" }}>{this.state.errors.events_Id}</div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col lg="4" md="4">
            <Form.Label style={{ paddingTop: "8px" }}>Action Type</Form.Label>
          </Col>
          <Col lg="8" md="8">
            <select
              className="form-select"
              value={this.state.actionType_Id}
              onChange={this.handleactionType_IdChange}
            >
              <option value="">Select Action Type</option>
              {this.state.actiontypes.map((api, index) => (
                <option key={index} value={api.eventactiontypemaster_Id}>
                  {api.actionType}
                </option>
              ))}
            </select>
            <div className="errorMsg" style={{ color: "red" }}>{this.state.errors.actionType_Id}</div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col lg="4" md="4">
            <Form.Label style={{ paddingTop: "8px" }}>Target Table Name</Form.Label>
          </Col>
          <Col lg="8" md="8">
            <Form.Control
              type="text"
              onChange={this.handletargetTableNameChange}
              className="form-control"
              name="targetTableName"
              value={this.state.targetTableName}
              placeholder="Enter target table name"
            />
          </Col>
          <div className="errorMsg" style={{ color: "red" }}>{this.state.errors.targetTableName}</div>
        </Row>
        <br />
        <Row>
          <Col lg="4" md="4">
            <Form.Label style={{ paddingTop: "8px" }}>Email Template Id</Form.Label>
          </Col>
          <Col lg="8" md="8">
            <Form.Control
              type="number"
              onChange={this.handleemailtemplates_IdChange}
              className="form-control"
              name="emailtemplates_Id"
              value={this.state.emailtemplates_Id}
              placeholder="Enter email template ID"
            />
          </Col>
          <div className="errorMsg" style={{ color: "red" }}>{this.state.errors.emailtemplates_Id}</div>
        </Row>
        <br />
        <Row>
          <Col lg="4" md="4">
            <Form.Label style={{ paddingTop: "8px" }}>Execution Order</Form.Label>
          </Col>
          <Col lg="8" md="8">
            <Form.Control
              type="text"
              onChange={this.handleexecutionOrderChange}
              className="form-control"
              name="executionOrder"
              value={this.state.executionOrder}
              placeholder="Enter execution order"
            />
          </Col>
          <div className="errorMsg" style={{ color: "red" }}>{this.state.errors.executionOrder}</div>
        </Row>
        <br />
        <Row>
          <Col lg="4" md="4">
            <Form.Label style={{ paddingTop: "8px" }}>API Call</Form.Label>
          </Col>
          <Col lg="8" md="8">
            <Form.Control
              type="text"
              onChange={this.handleapiCallChange}
              className="form-control"
              name="apiCall"
              value={this.state.apiCall}
              placeholder="Enter API call URL"
            />
          </Col>
          <div className="errorMsg" style={{ color: "red" }}>{this.state.errors.apiCall}</div>
        </Row>
        <br />
        <Row>
          <Col lg="4" md="4">
            <Form.Label style={{ paddingTop: "8px" }}>Is Active</Form.Label>
          </Col>
          <Col lg="8" md="8">
            <select
              className="form-select"
              value={this.state.isActive}
              onChange={this.handleisActiveChange}
            >
              <option value="">Select</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </Col>
          <div className="errorMsg" style={{ color: "red" }}>{this.state.errors.isActive}</div>
        </Row>
        <br />
        <Row>
          <Col lg="4" md="4">
            <Form.Label style={{ paddingTop: "8px" }}>Integration Library Id</Form.Label>
          </Col>
          <Col lg="8" md="8">
            <Form.Control
              type="number"
              onChange={this.handleintegrationlibrary_IdChange}
              className="form-control"
              name="integrationlibrary_Id"
              value={this.state.integrationlibrary_Id}
              placeholder="Enter integration library ID"
            />
          </Col>
        </Row>
        <br />

        {/* Field Mapping Section - only for DB-type actions */}
        {this.renderFieldMappingSection()}
      </Form>
    );
  };

  render() {
    const { errors } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        {this.state.isSubmitting && (
          <div className="submit-loader-overlay">
            <div className="loader-content">
              <div className="app-loader">Loading...</div>
            </div>
            <div className="loader-text">Processing your request...</div>
          </div>
        )}
        
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>
                        Event Actions
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      {/* Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "600px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Event Action</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ overflowY: "auto", height: "auto" }}>
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}
                            <Row className="divstyle">
                              <Row>{this.renderFormFields()}</Row>
                            </Row>
                            <Row>
                              <Col className="d-flex justify-content-end" style={{ marginRight: "50px" }}>
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.EventactionssubmitHandler}
                                  disabled={this.state.isSubmitting || !this.isFormValid()}
                                  style={{ marginTop: "20px" }}
                                >
                                  {this.state.isSubmitting ? (
                                    <>
                                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                      Saving...
                                    </>
                                  ) : (
                                    "Save"
                                  )}
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "600px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Event Action</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ overflowY: "auto", height: "auto" }}>
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                              <Row className="divstyle">
                                <Row>{this.renderFormFields()}</Row>
                              </Row>
                              <Row>
                                <Col className="d-flex justify-content-end" style={{ marginRight: "50px" }}>
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.EventactionsupdateHandler}
                                    disabled={this.state.isSubmitting || !this.isFormValid()}
                                    style={{ marginTop: "20px" }}
                                  >
                                    {this.state.isSubmitting ? (
                                      <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                        Updating...
                                      </>
                                    ) : (
                                      "Update"
                                    )}
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus"
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={this.state.itemsPerPage}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
